export type ScannerPhase = "center-field" | "hits";

export interface ScannerStep {
  phase: ScannerPhase;
  targetIndex: number;
}

export type PreviousScannerDestination = ScannerStep | { phase: "session-data" };
export type NextScannerDestination = ScannerStep | { phase: "report" };

export const restoreHitMarkersWithRadius = <T extends { radius: number }>(markers: T[], radius: number): T[] => {
  return markers.map((marker) => ({ ...marker, radius }));
};

export const getPreviousScannerStep = (step: ScannerStep): PreviousScannerDestination => {
  if (step.phase === "hits") {
    return { phase: "center-field", targetIndex: step.targetIndex };
  }

  if (step.targetIndex > 0) {
    return { phase: "hits", targetIndex: step.targetIndex - 1 };
  }

  return { phase: "session-data" };
};

export const getNextScannerStep = (step: ScannerStep, numberOfTargets: number): NextScannerDestination => {
  if (step.phase === "center-field") {
    return { phase: "hits", targetIndex: step.targetIndex };
  }

  if (step.targetIndex < numberOfTargets - 1) {
    return { phase: "center-field", targetIndex: step.targetIndex + 1 };
  }

  return { phase: "report" };
};
